import './App.css'
import MainLayout from './layout/index'
import { Routes, Route } from 'react-router-dom'
import Index from './components/Index'
import Ticker from './components/ticker/Index'
import Zhihu from './components/Zhihu'
import Announcement from './components/Announcement'
import WordCount from './components/WordCount'
import Src from './components/Src'
import Google from './components/Google'
import Video from './components/Video'
import Audio from './components/Audio'
import Md5 from './components/Md5'
import Merge from './components/Merge'
import Idcard from './components/Idcard'
import Ps from './components/Ps'
import Ocr from './components/Ocr'
import Timestamp from './components/Timestamp'
import Euro from './components/Euro'
import Image2Pdf from './components/Image2Pdf'
import MergePdf from './components/MergePdf'
import MergeDoc from './components/MergeDoc'
import Doc2Pdf from './components/Doc2Pdf'
import Json2Excel from './components/Json2Excel'
import Grid from './components/Grid'
import Pdf2Image from './components/Pdf2Image'

import { HashRouter } from 'react-router-dom'
import { useReducer } from 'react'
import { MyContext } from './context'
import loginReducer from './reducer'
function App() {
  const [isLogin, dispatch] = useReducer(
    loginReducer,
    localStorage.getItem('logined')
  ) //创建reducer

  return (
    <MyContext.Provider value={{ isLogin, dispatch }}>
      <HashRouter>
        <MainLayout>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="btc" element={<Ticker />} />
            <Route path="announcement" element={<Announcement />} />
            <Route path="zhihu" element={<Zhihu />} />
            <Route path="wordcount" element={<WordCount />} />
            <Route path="src" element={<Src />} />
            <Route path="google" element={<Google />} />
            <Route path="video" element={<Video />} />
            <Route path="audio" element={<Audio />} />
            <Route path="md5" element={<Md5 />} />
            <Route path="merge" element={<Merge />} />
            <Route path="image2pdf" element={<Image2Pdf />} />
            <Route path="pdf2image" element={<Pdf2Image />} />
            <Route path="mergePdf" element={<MergePdf />} />
            <Route path="mergeDoc" element={<MergeDoc />} />
            <Route path="doc2Pdf" element={<Doc2Pdf />} />
            <Route path="json2excel" element={<Json2Excel />} />
            <Route path="grid" element={<Grid />} />
            <Route path="idcard" element={<Idcard />} />
            <Route path="ps" element={<Ps />} />
            <Route path="ocr" element={<Ocr />} />
            <Route path="timestamp" element={<Timestamp />} />
            <Route path="Euro" element={<Euro />} />
          </Routes>
        </MainLayout>
      </HashRouter>
    </MyContext.Provider>
  )
}

export default App
